import React, { useRef } from "react";

import "./contact.css"; // optional styling
import { toast } from 'react-toastify';


const ContactForm = () => {
  const form = useRef();
  const BACKEND_URL = "https://rcsbackend.onrender.com"; // ✅ LIVE BACKEND URL

  const sendEmail = async (e) => {
    e.preventDefault();
  
    const formData = new FormData(form.current);
    const name = formData.get("name");
    const email = formData.get("email");
    const message = formData.get("message");
    const phone = formData.get("phone");

    try {
      const res = await fetch(`${BACKEND_URL}/send-contact`, {


        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, phone, message }),
      });
  
      const data = await res.json();
      if (data.success) {
        toast.success("✅ Message sent successfully!");
        form.current.reset();
      } else {
        toast.error("❌ Failed to send message.");
      }
    } catch (err) {
      console.error("❌ Server error:", err);
      toast.error("❌ Could not send message. Try again later.");
    }
  };
  

  return (
    <form ref={form} onSubmit={sendEmail} className="contact-form">
      <label>Name</label>
      <input type="text" name="name" required placeholder="Your Name" />

      <label>Contact Number</label>
      <input type="tel" name="phone" required placeholder="Your Contact Number" />


      <label>Email</label>
      <input type="email" name="email" required placeholder="Your Email" />

      <label>Message</label>
      <textarea name="message" required placeholder="Your Message" rows={5}></textarea>

      <button type="submit">Send Message</button>

    </form>
  );
};

export default ContactForm;
